<main class="onboarding-my-queue-page">
  <div class="onboarding-my-queue-shell">
    <section class="onboarding-queue-card">
      <div class="onboarding-queue-card-header d-flex align-items-center justify-content-between gap-3">
        <div class="min-w-0">
          <h2 class="onboarding-queue-card-title">{{ is_exact_entity_role() ? 'My onboardings' : 'All onboardings' }}</h2>
          <span class="onboarding-queue-count">{{ filtered_queue_items.length }} ONBOARDING(S)</span>
        </div>

        <div class="onboarding-queue-header-tools d-flex align-items-center justify-content-end flex-wrap gap-2">
          <label class="onboarding-queue-search d-inline-flex align-items-center" for="onboarding-queue-search">
            <i class="bi bi-search" aria-hidden="true"></i>
            <input
              id="onboarding-queue-search"
              v-model="queue_search"
              type="search"
              placeholder="Search table"
              autocomplete="off"
            >
          </label>

          <select
            v-model="queue_stage_filter"
            class="onboarding-queue-filter"
            aria-label="Filter table by stage"
          >
            <option value="">All stages</option>
            <option
              v-for="stage in queue_stage_filter_options"
              :key="stage"
              :value="stage"
            >
              {{ stage }}
            </option>
          </select>

          <select
            v-model="queue_risk_filter"
            class="onboarding-queue-filter"
            aria-label="Filter table by risk"
          >
            <option value="">All risks</option>
            <option
              v-for="risk in queue_risk_filter_options"
              :key="risk"
              :value="risk"
            >
              {{ risk }}
            </option>
          </select>
        </div>
      </div>

      <div v-if="is_loading_queue || is_filtering_queue" class="text-center text-muted py-5">
        {{ queue_loading_label }}
      </div>

      <div v-else-if="queue_error" class="alert alert-warning m-3">
        {{ queue_error }}
      </div>

      <div v-else-if="queue_items.length === 0" class="text-center text-muted py-5">
        {{ is_exact_entity_role() ? 'No onboardings are assigned to your login yet.' : 'No open items assigned to you.' }}
      </div>

      <div v-else-if="filtered_queue_items.length === 0" class="text-center text-muted py-5">
        No queue items match the current table filters.
      </div>

      <div v-else class="onboarding-queue-list">
        <div class="onboarding-queue-table-head" aria-hidden="true">
          <div class="onboarding-queue-table-head__case">Entity / applicant</div>
          <div class="onboarding-queue-table-head__journey">Journeys</div>
          <div class="onboarding-queue-table-head__status">Stage</div>
          <div class="onboarding-queue-table-head__risk">Risk</div>
          <div class="onboarding-queue-table-head__activate">SLA</div>
          <div class="onboarding-queue-table-head__actions">Actions</div>
        </div>

        <article
          v-for="item in paginated_queue_items"
          :key="item.id || `${item.title}-${item.gate}-${item.due}`"
          class="onboarding-queue-row d-grid align-items-center cursor-pointer"
          tabindex="0"
          role="button"
          @click="open_queue_item(item)"
          @keyup.enter="open_queue_item(item)"
        >
          <div :class="['onboarding-queue-status', `is-${item.status}`]">
            <i :class="['bi', status_icon(item.status)]"></i>
          </div>

          <div class="onboarding-queue-details min-w-0">
            <h3 class="onboarding-queue-item-title text-truncate">{{ item.title }}</h3>
            <div class="onboarding-queue-meta d-flex align-items-center flex-wrap">
              <span class="onboarding-queue-company">{{ item.company }}</span>
              <span class="onboarding-queue-dot">&middot;</span>
              <span class="onboarding-queue-progress">{{ item.progress }}</span>
            </div>
          </div>

          <div class="onboarding-queue-journey">
            <span class="onboarding-queue-journey-label">{{ item.journey }}</span>
          </div>

          <div class="onboarding-queue-current-status">
            <span :class="['onboarding-status-pill', `is-${queue_status_tone(item)}`]">
              {{ queue_status_label(item) }}
            </span>
          </div>

          <div class="onboarding-queue-risk">
            <span :class="['onboarding-priority-pill', `is-${item.priority.toLowerCase()}`]">
              {{ item.priority }}
            </span>
          </div>

          <div class="onboarding-queue-activate">
            <span class="onboarding-queue-due">{{ item.due }}</span>
          </div>

            <div class="onboarding-queue-action">
              <button
                v-if="!is_exact_entity_role()"
                type="button"
                class="onboarding-queue-view-button"
                :disabled="queue_action_key === `edit:${item.case_item?.application_id}`"
                @click.stop="open_edit_for_item(item, $event)"
              >
                <span>{{ queue_action_key === `edit:${item.case_item?.application_id}` ? 'Opening...' : 'Edit' }}</span>
              </button>
                <button
                  v-if="!is_exact_entity_role()"
                  type="button"
                  class="onboarding-queue-view-button d-none"
                  @click.stop="launch_esigning_for_case(item.case_item || item, $event)"
                >
                  <span>E-sign</span>
                </button>
              <button
                type="button"
                class="onboarding-queue-view-button"
                :disabled="queue_action_key === `form:${item.case_item?.application_id}`"
                @click.stop="open_queue_form(item, $event)"
            >
              <span>
                {{ queue_action_key === `form:${item.case_item?.application_id}` ? 'Opening...' : (is_exact_entity_role() ? 'Continue' : 'View') }}
              </span>
              <i class="bi bi-arrow-right-short" aria-hidden="true"></i>
            </button>
          </div>
        </article>
      </div>

      <TablePagination
        v-if="filtered_queue_items.length > 0"
        :page="table_page"
        :page-size="table_page_size"
        :page-size-options="table_page_size_options"
        :total-rows="table_total_rows"
        :page-start="table_page_start"
        :page-end="table_page_end"
        :total-pages="table_total_pages"
        @update:page="set_table_page"
        @update:page-size="set_table_page_size"
      />
    </section>
  </div>

  <div
    v-if="selected_case"
    class="onboarding-case-detail-backdrop"
    @click="close_case_detail"
  ></div>

  <aside
    v-if="selected_case"
    class="onboarding-case-detail-drawer bg-white shadow-lg"
  >
    <header class="border-bottom p-4">
      <div class="d-flex align-items-start justify-content-between gap-3">
        <div class="min-w-0">
          <div class="text-uppercase text-muted fw-semibold small mb-3">
            {{ selected_case.journey }} onboarding - {{ selected_case.stage }}
          </div>
          <div class="d-flex align-items-center gap-2 flex-wrap mb-2">
            <h2 class="h5 fw-bold text-black mb-0">{{ selected_case.name }}</h2>
            <EntityNameEditButton
              :entity-record="selected_case"
              :current-name="selected_case.name"
              @updated="selected_case.name = $event.name"
            />
          </div>
          <p class="mb-0 text-muted">
            {{ selected_case_header_summary() }}
          </p>
        </div>

        <div class="d-flex align-items-center gap-3 flex-shrink-0">
          <span :class="['badge rounded-pill fw-normal', activation_badge_class(selected_case.activation_tone)]">
            {{ selected_case.activation }}
          </span>
          <button type="button" class="btn btn-link text-muted p-0" aria-label="Close entity detail" @click="close_case_detail">
            <i class="bi bi-x-lg fs-5"></i>
          </button>
        </div>
      </div>
    </header>

    <div class="onboarding-case-detail-body p-4">
      <div class="onboarding-detail-tabs-shell mb-4">
        <button
          v-if="detail_tab_overflow.left"
          type="button"
          class="onboarding-detail-tabs__nav onboarding-detail-tabs__nav--left"
          aria-label="Scroll section tabs left"
          @click="scroll_detail_tabs('left')"
        >
          <i class="bi bi-chevron-left"></i>
        </button>

        <nav
          ref="detailTabsScroller"
          class="bg-light rounded-3 p-1 d-flex align-items-center gap-2 onboarding-detail-tabs"
          aria-label="Entity detail sections"
          @scroll="update_detail_tab_overflow"
        >
          <button
            v-for="tab in detail_tabs"
            :key="tab.id"
            :data-detail-tab-id="tab.id"
            type="button"
            :class="[
              'btn btn-sm d-inline-flex align-items-center justify-content-center gap-2 onboarding-detail-tabs__button',
              `is-${detail_tab_tone(tab)}`,
              active_detail_tab === tab.id ? 'is-active fw-semibold' : 'border-0 bg-transparent'
            ]"
            @click="set_detail_tab(tab.id)"
          >
            <i :class="['bi', tab.icon]"></i>
            <span>{{ tab.label }}</span>
            <span v-if="tab.count" class="badge rounded-pill text-bg-secondary">{{ tab.count }}</span>
          </button>
        </nav>

        <button
          v-if="detail_tab_overflow.right"
          type="button"
          class="onboarding-detail-tabs__nav onboarding-detail-tabs__nav--right"
          aria-label="Scroll section tabs right"
          @click="scroll_detail_tabs('right')"
        >
          <i class="bi bi-chevron-right"></i>
        </button>
      </div>

      <section v-if="active_detail_tab === 'summary'">
        <div v-if="is_loading_detail" class="text-muted mb-4">Loading entity detail...</div>

        <dl class="row g-0 mb-4">
          <template v-for="row in summary_rows" :key="row.label">
            <dt class="col-4 text-muted fw-normal mb-3">{{ row.label }}</dt>
            <dd class="col-8 fw-semibold mb-3">{{ row.value }}</dd>
          </template>
        </dl>

        <section class="mb-4">
          <div class="text-uppercase text-muted fw-semibold small mb-3">Overall readiness</div>
          <div class="d-flex align-items-center gap-3">
            <div class="progress flex-grow-1 onboarding-progress-track">
              <div class="progress-bar onboarding-progress-bar" :style="{ '--onboarding-progress-size': `${selected_case.progress}%` }"></div>
            </div>
            <span class="small fw-bold">{{ selected_case.progress }}%</span>
          </div>
        </section>

        <section v-if="compliance_panel" class="mb-4">
          <div class="d-flex align-items-center justify-content-between gap-3 mb-3">
            <div>
              <div class="text-uppercase text-muted fw-semibold small mb-1">Compliance</div>
              <div class="fw-bold text-black">{{ compliance_panel.status_label }}</div>
            </div>
            <div class="d-flex align-items-center gap-2">
              <span :class="['badge rounded-pill', compliance_tone_class(compliance_panel.tone)]">
                {{ compliance_panel.evaluated_count }} evaluated
              </span>
              <button
                v-if="!is_exact_entity_role()"
                type="button"
                class="onboarding-compliance-evaluate-button"
                :disabled="Boolean(compliance_action_key)"
                @click="run_selected_case_compliance"
              >
                <i :class="['bi', compliance_action_key ? 'bi-arrow-repeat' : 'bi-shield-check']"></i>
                <span>{{ compliance_action_key ? 'Evaluating...' : 'Evaluate' }}</span>
              </button>
            </div>
          </div>

          <div v-if="compliance_error" class="alert alert-danger py-2 small mb-3">
            {{ compliance_error }}
          </div>

          <div v-if="compliance_panel.message" class="text-muted small mb-3">
            {{ compliance_panel.message }}
          </div>

          <div v-if="compliance_panel.tags.length" class="d-flex flex-wrap gap-2 mb-3">
            <span
              v-for="tag in compliance_panel.tags"
              :key="tag"
              class="badge rounded-pill bg-info-subtle text-info-emphasis"
            >
              {{ tag }}
            </span>
          </div>

          <div v-if="compliance_panel.rules.length" class="border rounded-3 overflow-hidden">
            <article
              v-for="rule in compliance_panel.rules"
              :key="rule.id"
              class="d-flex align-items-start gap-3 p-3 border-bottom"
            >
              <span :class="['rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0 onboarding-icon-square-17', compliance_tone_class(rule.tone)]">
                <i :class="['bi', compliance_rule_icon(rule)]"></i>
              </span>
              <div class="min-w-0 flex-grow-1">
                <div class="fw-semibold text-black">{{ rule.name }}</div>
                <div v-if="rule.message" class="text-muted small mt-1">{{ rule.message }}</div>
                <div v-if="rule.last_evaluated" class="text-muted small mt-1">Last evaluated {{ rule.last_evaluated }}</div>
              </div>
              <span :class="['badge rounded-pill flex-shrink-0', compliance_tone_class(rule.tone)]">
                {{ rule.outcome }}
              </span>
            </article>
          </div>

          <div v-if="compliance_panel.actions_taken.length" class="mt-3">
            <div class="text-uppercase text-muted fw-semibold small mb-2">Actions taken</div>
            <article
              v-for="action in compliance_panel.actions_taken"
              :key="action.id"
              class="d-flex align-items-center justify-content-between gap-3 py-2 border-bottom"
            >
              <div>
                <div class="fw-semibold text-black">{{ action.rule_name }}</div>
                <div class="text-muted small">{{ action.outcome || 'No outcome' }}</div>
              </div>
              <span class="badge rounded-pill bg-light text-secondary">
                {{ action.action_count }} action{{ action.action_count === 1 ? '' : 's' }}
              </span>
            </article>
          </div>
        </section>

        <section class="mb-4">
          <div class="text-uppercase text-muted fw-semibold small mb-3">Stage timeline</div>
          <div class="onboarding-case-timeline">
            <article
              v-for="item in stage_timeline"
              :key="item.title"
              :class="['onboarding-case-timeline-item', `is-${item.status}`]"
            >
              <span class="onboarding-case-timeline-icon">
                <i :class="['bi', item.icon]"></i>
              </span>
              <div>
                <div class="fw-semibold text-black">{{ item.title }}</div>
                <div class="text-muted small mt-1">{{ item.detail }}</div>
              </div>
            </article>
          </div>
        </section>

        <section v-if="evidence_items.length">
          <div class="text-uppercase text-muted fw-semibold small mb-3">Evidence & checks</div>
          <article
            v-for="item in evidence_items"
            :key="item.id || item.title"
            class="d-flex align-items-center gap-3 py-3 border-bottom"
          >
            <span class="rounded-circle d-inline-flex align-items-center justify-content-center bg-success-subtle text-success-emphasis flex-shrink-0 onboarding-icon-square-17">
              <i :class="['bi', item.icon]"></i>
            </span>
            <div class="min-w-0 flex-grow-1">
              <div class="fw-semibold text-black">{{ item.title }}</div>
              <div class="text-muted small">{{ item.detail }}</div>
            </div>
            <span :class="['badge rounded-pill', item.tone_class]">{{ item.status }}</span>
          </article>
        </section>
      </section>

      <section v-else-if="active_detail_tab === 'agreements'">
        <div class="d-flex align-items-center justify-content-between mb-3">
          <div class="text-uppercase text-muted fw-semibold small">Agreements &amp; e-signing</div>
          <div class="text-uppercase text-muted fw-semibold small">{{ agreement_rows.length }} document(s)</div>
        </div>

        <div class="d-grid gap-3">
          <article
            v-for="agreement in agreement_rows"
            :key="agreement.id"
            class="border rounded-3 p-3"
          >
            <div class="d-flex align-items-start gap-3">
              <span :class="['rounded-3 d-inline-flex align-items-center justify-content-center flex-shrink-0 onboarding-icon-square-21', agreement.icon_class]">
                <i :class="['bi', agreement.icon]"></i>
              </span>
              <div class="min-w-0 flex-grow-1">
                <div class="fw-bold text-black mb-1">{{ agreement.title }}</div>
                <div class="text-muted small">{{ agreement.signed_by_detail }}</div>
              </div>
              <div class="d-flex flex-column align-items-end gap-3 flex-shrink-0">
                <span :class="['badge rounded-pill', agreement.status_class]">
                  <span class="me-1">&bull;</span>{{ agreement.status }}
                </span>
                <button
                  type="button"
                  v-if="agreement.submission_id"
                  :disabled="agreement_download_key === String(agreement.id)"
                  @click="download_agreement_document(agreement)"
                  class="btn btn-link btn-sm text-muted text-decoration-none d-inline-flex align-items-center gap-2 p-0"
                >
                  <i class="bi bi-download"></i>
                  <span>{{ agreement_download_key === String(agreement.id) ? 'Loading...' : 'Download' }}</span>
                </button>
              </div>
            </div>
          </article>

          <p v-if="agreement_rows.length === 0" class="text-muted mb-0">
            No signed agreements are available for this onboarding yet.
          </p>
        </div>
      </section>

      <section v-else-if="active_form_section_tab">
        <div class="d-flex align-items-center justify-content-between mb-4">
          <div>
            <div class="text-uppercase text-muted fw-semibold small mb-1">{{ active_form_section_tab.form_name }}</div>
            <div class="fw-bold text-black">{{ active_form_section_tab.section.label }}</div>
          </div>
          <span
            v-if="active_form_section_is_document_section"
            class="badge rounded-pill bg-info-subtle text-info-emphasis"
          >
            Uploads
          </span>
        </div>

        <div
          v-for="sub_section in active_form_section_tab.section.sub_sections"
          :key="sub_section.id"
          class="mb-3"
        >
          <div
            v-if="sub_section.label && sub_section.label.toLowerCase() !== active_form_section_tab.section.label.toLowerCase()"
            class="onboarding-form-subsection-title"
          >
            {{ sub_section.label }}
          </div>

          <div
            v-if="active_form_section_is_document_section"
            class="onboarding-document-list"
          >
            <article
              v-for="question in sub_section.questions"
              :key="question.id"
              class="onboarding-document-row"
            >
              <div :class="['onboarding-document-status-icon', document_status_meta(question).icon_class]">
                <i :class="['bi', document_status_meta(question).icon]"></i>
              </div>

              <div class="onboarding-document-row__content">
                <div class="onboarding-document-row__title">
                  {{ question.label }}
                  <span v-if="question.is_mandatory" class="text-danger">*</span>
                </div>
                <div class="onboarding-document-row__detail">
                  {{ document_answer_meta(question).uploaded ? document_answer_meta(question).name : 'Awaiting upload' }}
                </div>
                <div class="onboarding-document-row__meta">
                  <span class="onboarding-document-card__meta">
                    <i :class="['bi', is_document_question(question) ? 'bi-file-earmark-arrow-up' : 'bi-card-text']"></i>
                    <span>{{ is_document_question(question) ? 'Document upload' : 'Submitted response' }}</span>
                  </span>
                </div>
              </div>

              <div class="onboarding-document-row__actions">
                <span :class="['badge rounded-pill onboarding-document-status-pill', document_status_meta(question).pill_class]">
                  {{ document_status_meta(question).label }}
                </span>

                <a
                  v-if="document_answer_meta(question).url"
                  :href="document_answer_meta(question).url"
                  target="_blank"
                  rel="noreferrer"
                  class="btn btn-sm btn-outline-primary d-inline-flex align-items-center gap-2 onboarding-document-open-button"
                >
                  <i class="bi bi-box-arrow-up-right"></i>
                  <span>Open file</span>
                </a>
              </div>
            </article>
          </div>

          <div v-else class="onboarding-answer-grid">
            <article
              v-for="question in sub_section.questions"
              :key="question.id"
              :class="['onboarding-answer-card', `is-${section_tone(active_form_section_tab.section.label)}`]"
            >
              <p class="onboarding-answer-card__label">
                {{ question.label }}
                <span v-if="question.is_mandatory" class="text-danger">*</span>
              </p>
              <div class="onboarding-answer-card__value">
                {{ question.answer }}
              </div>
            </article>
          </div>
        </div>
      </section>
    </div>
  </aside>

  <div
    v-if="show_edit_modal"
    class="modal fade show d-block"
    tabindex="-1"
    role="dialog"
    aria-modal="true"
    @click.self="close_edit_modal"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg" @click.stop>
      <div class="modal-content border-0 shadow rounded-4 overflow-hidden">
        <div class="modal-header border-bottom px-4 py-4 align-items-start position-relative">
          <div>
            <h3 class="h4 fw-bold mb-2">Edit onboarding</h3>
            <p class="text-muted mb-0">
              Select a journey and template; OnboardOS sets the required documents, verifications,
              approvals and activation conditions.
            </p>
          </div>
          <button
            type="button"
            class="btn btn-link text-muted p-0 position-absolute top-0 end-0 mt-4 me-4"
            aria-label="Close edit modal"
            @click="close_edit_modal"
          >
            <i class="bi bi-x-lg fs-5"></i>
          </button>
        </div>

        <div class="modal-body px-4 py-4 bg-white">
          <div v-if="edit_error" class="alert alert-warning py-2">
            {{ edit_error }}
          </div>

          <div class="mb-4">
            <label class="form-label text-uppercase text-muted fw-bold small">Candidate / Company name</label>
            <select v-model="edit_form.candidate_name" class="form-select">
              <option :value="edit_form.candidate_name">{{ edit_form.candidate_name || 'Select candidate / company name' }}</option>
            </select>
          </div>

          <div class="row g-3 mb-4">
            <div class="col-md-6">
              <label class="form-label text-uppercase text-muted fw-bold small">Journey</label>
              <select
                v-model="edit_form.journey"
                class="form-select"
                @change="handle_edit_journey_change"
              >
                <option value="">Select journey</option>
                <option
                  v-for="journey in available_edit_journeys"
                  :key="journey.id"
                  :value="journey.name"
                >
                  {{ journey.name }}
                </option>
              </select>
            </div>
            <div class="col-md-6">
              <label class="form-label text-uppercase text-muted fw-bold small">Template</label>
              <div class="position-relative onboarding-create-template-picker">
                <button
                  type="button"
                  class="form-select text-start"
                  :disabled="!available_edit_templates.length"
                  @click="toggle_edit_template_dropdown"
                >
                  {{ edit_template_label() }}
                </button>

                <div
                  v-if="show_edit_template_dropdown"
                  class="template-multiselect-menu rounded-2 shadow-sm mt-1"
                >
                  <div class="onboarding-create-template-search p-2">
                    <input
                      v-model="edit_template_search"
                      type="search"
                      class="form-control"
                      placeholder="Search template"
                      @click.stop
                    >
                  </div>

                  <label
                    v-for="template in filtered_edit_templates()"
                    :key="template.id"
                    class="dropdown-item template-multiselect-item d-flex align-items-center gap-2 py-2 mb-0"
                  >
                    <input
                      type="checkbox"
                      class="form-check-input mt-0"
                      :checked="is_edit_template_selected(template.id)"
                      @change="toggle_edit_template(template)"
                    >
                    <span class="text-truncate">{{ template.name }}</span>
                  </label>

                  <div
                    v-if="!filtered_edit_templates().length"
                    class="dropdown-item text-muted template-multiselect-item py-2"
                  >
                    {{ edit_form.journey ? 'No backend templates found' : 'Select journey first' }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row g-3 mb-4">
            <div class="col-md-6">
              <label class="form-label text-uppercase text-muted fw-bold small">Owner</label>
              <div class="position-relative onboarding-create-owner-picker">
                <button
                  type="button"
                  class="form-select text-start"
                  :disabled="!available_owner_roles.length"
                  @click="toggle_edit_owner_dropdown"
                >
                  {{ edit_owner_role_label() }}
                </button>

                <div
                  v-if="show_edit_owner_dropdown"
                  class="template-multiselect-menu rounded-2 shadow-sm mt-1"
                >
                  <div class="onboarding-create-owner-search p-2">
                    <input
                      v-model="edit_owner_role_search"
                      type="search"
                      class="form-control"
                      placeholder="Search role"
                      @click.stop
                    >
                  </div>

                  <label
                    v-for="role in filtered_edit_owner_roles()"
                    :key="role.id"
                    class="dropdown-item template-multiselect-item d-flex align-items-center gap-2 py-2 mb-0"
                  >
                    <input
                      type="checkbox"
                      class="form-check-input mt-0"
                      :checked="is_edit_owner_role_selected(role.id)"
                      @change="toggle_edit_owner_role(role)"
                    >
                    <span class="text-truncate">{{ role.name }}</span>
                  </label>

                  <div
                    v-if="!filtered_edit_owner_roles().length"
                    class="dropdown-item text-muted template-multiselect-item py-2"
                  >
                    No roles found
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <label class="form-label text-uppercase text-muted fw-bold small">Activate by</label>
              <input v-model="edit_form.activate_by" type="date" class="form-control">
            </div>
          </div>

          <div class="mb-4">
            <label class="form-label text-uppercase text-muted fw-bold small">Onboarding name</label>
            <input
              v-model="edit_form.onboarding_name"
              type="text"
              class="form-control"
              placeholder="Enter onboarding name"
            >
          </div>

          <div class="form-check form-switch mb-1 ps-0 d-flex align-items-center gap-2">
            <input
              id="edit-allow-login"
              v-model="edit_form.allow_login"
              class="form-check-input ms-0"
              type="checkbox"
            >
            <label class="form-check-label" for="edit-allow-login">
              Allow login - create user account with email invitation
            </label>
          </div>
          <p class="text-muted small mb-3">
            When enabled, this person can log in and complete their onboarding forms.
          </p>

          <div class="mb-4">
            <label class="form-label text-uppercase text-muted fw-bold small">Email</label>
            <input
              v-model="edit_form.email"
              type="email"
              class="form-control"
              placeholder="Enter email address"
            >
          </div>

          <div>
            <div class="text-uppercase text-muted fw-bold small mb-2">Required at submit</div>
            <p class="text-muted mb-2 small">No main sections returned for this template.</p>
            <p class="text-muted mb-0 small">
              Selected items must be attached before the onboarding can advance past Documents.
            </p>
          </div>
        </div>

        <div class="modal-footer border-top px-4 py-3 bg-white d-flex justify-content-end gap-3">
          <button type="button" class="btn btn-link text-muted fw-semibold text-decoration-none" @click="close_edit_modal">Cancel</button>
          <button
            type="button"
            class="btn text-white px-4 py-2 border-0 onboarding-edit-update-button"
            :disabled="is_saving_case_edits"
            @click="save_case_edits"
          >
            <span>{{ is_saving_case_edits ? 'Updating...' : 'Update' }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div v-if="show_edit_modal" class="modal-backdrop fade show"></div>

</main>
